module.exports = __webpack_public_path__ + "img/1-25-5.5c2e770f.png";